import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LogsData } from 'app/df-management/shared/df-management-logs.modal';
import { DFCountry, DFCountryCarrierList } from 'app/df-management/shared/df-management.coutry.model';
import { DfManagementService } from 'app/df-management/shared/df-management.service';
import {  DFStatus, MyDFStatusCountList } from 'app/df-management/shared/df-transaction-data.model';
import { NotificationsService } from 'app/df-management/shared/notifications.service';
import { ClipboardService } from 'app/shared/services/clipboard.service';
import { DataTableColumn, DataTableComponent } from 'app/shared/data-table/data-table.component';
import { LoaderService } from 'app/shared/services/loader.service';
import { NavigationService } from 'app/shared/services/navigation.service';
import { SearchObjectResult } from 'app/shared/search-object-result.model';
import { JsonEditorService } from 'app/shared/services/json-editor.service';
import { SortDirection } from 'app/shared/sort-direction';
import * as moment from 'moment';
import { Moment } from 'moment';
import { IDatePickerConfig, IDatePickerDirectiveConfig } from 'ng2-date-picker';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-capture-logs',
  templateUrl: './capture-logs.component.html',
  styleUrls: ['./capture-logs.component.scss']
})
export class CaptureLogsComponent implements OnInit {
@ViewChild('jobNameColumn', { static: true })
jobNameColumn: TemplateRef<any>;

@ViewChild('jobTypeColumn', { static: true })
jobTypeColumn: TemplateRef<any>;

@ViewChild('jobStatusColumn', { static: true })
jobStatusColumn: TemplateRef<any>;

@ViewChild('logDateColumn', { static: true })
logDateColumn: TemplateRef<any>;

@ViewChild('durationColumn', { static: true })
durationColumn: TemplateRef<any>;

@ViewChild('recordProcessedColumn', { static: true })
recordProcessedColumn: TemplateRef<any>;

@ViewChild('responseInsightColumn', { static: true })
responseInsightColumn: TemplateRef<any>;

@ViewChild(DataTableComponent, { static : true })
logsListTable: DataTableComponent;
  columns: DataTableColumn[] = [];
  sortColumn: DataTableColumn;
  SortDirection = SortDirection.ASC;
  searchForm: FormGroup;
  countryData: DFCountryCarrierList[] = [];
  selectCountry: string;
  selectJobs: string;
  selectDate: string;
  selectStatus: string;
  dateConfig: IDatePickerDirectiveConfig;
  dayConfig: IDatePickerDirectiveConfig;
  @Input()
  maxDate: Moment;
  @Input()
  minDate: Moment;
  logsList: LogsData[] = [];
  countryCode: string;
  filters: any = {}
  pageTransData: MyDFStatusCountList;
  statusList: DFStatus[] = [] ;
  statusCode: string;
  selectedCard: string;
  isVisibleCards = false;
  isPopupVisible!: Observable<boolean>;

  jobs = [
    { id: 1, name: 'All'},
    { id: 2, name: 'Asset Search'},
    { id: 3, name: 'Load Search' },
    { id: 4, name: 'Auto Calculation' },
    { id: 5, name: 'Voucher Update'}
  ];
  selectedJobs = [];
  status = []
  loadPage: (...config) => Observable<SearchObjectResult<LogsData>> = null;

  constructor(public navigationService: NavigationService,
    private fb: FormBuilder, private dfManagementService: DfManagementService,
    private toastr: ToastrService,
    private loader: LoaderService,
    private translate: TranslateService,
    private jsonEditorService: JsonEditorService,
    private clipboard: ClipboardService,
    private notificationService: NotificationsService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.isPopupVisible = this.notificationService.isPopupVisible;

    this.dateConfig = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'mo',
      format: 'YYYY-MM-DD',
      max: null,
      min: null,
      disableKeypress: false,
      unSelectOnClick: true,
    }
    this.dayConfig = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'mo',
      format: 'YYYY-MM-DD',
      isDayDisabledCallback: (date: Moment) => {
        return (date.diff(moment().utc().format('YYYY-MM-DD'), 'days') > 0);
      },
      max: null,
      min: null,
      disableKeypress: false,
      unSelectOnClick: true,
    }

    this.getDFCountryResponse();
    this.displayColumns();
  }

  displayColumns() {
    const jobStartDate = {
      name: 'jobStartDate',
        displayed: true,
        translationKey: 'Log Date & Time',
        template: this.logDateColumn,
        sortable: true,
        alignRight: false,
        alignCenter: true,
    }
    this.columns = [
      {
        name: 'jobName',
        displayed: true,
        translationKey: 'Job Name',
        template: this.jobNameColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'jobType',
        displayed: true,
        translationKey: 'Job Type',
        template: this.jobTypeColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'jobStatus',
        displayed: true,
        translationKey: 'Job Status',
        template: this.jobStatusColumn,
        sortable: false,
        alignCenter: true,
      },
      jobStartDate,
      {
        name: 'duration',
        displayed: true,
        translationKey: 'Duration',
        template: this.durationColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'recordProcessed',
        displayed: true,
        translationKey: 'Records Processed',
        template: this.recordProcessedColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'responseInsight',
        displayed: true,
        translationKey: 'Response Insight',
        template: this.responseInsightColumn,
        sortable: false,
        alignCenter: true,
      },
    ];
    this.sortColumn =  jobStartDate;
    }

  initializeForm(): void {
    this.searchForm = this.fb.group({
      country: [null, Validators.required],
      selectedJobs: [''],
      startDate: [''],
      endDate: [''],
      status: [null]
    }, {
      validator: this.dateRangeValidator
    });
  }

  resetSearchData() {
  if (this.countryCode) {
      this.searchForm.controls['selectedJobs'].reset();
      this.searchForm.controls['startDate'].reset();
      this.searchForm.controls['endDate'].reset();
      this.searchForm.controls['status'].reset();
      this.selectedCard = null;
      this.applySearch()
    }
  }

  translatePlaceholders() {
    this.selectCountry = this.translate.instant('df-management.filters.placeholder.select-country');
    this.selectJobs = this.translate.instant('df-management.filters.placeholder.select-job');
    this.selectDate  = this.translate.instant('df-management.filters.placeholder.select-date');
    this.selectStatus = this.translate.instant('df-management.filters.placeholder.select-status')
  }

  onSelectionChange(selectedJobs) {
    this.selectedJobs = selectedJobs;
    const allJob = this.jobs.find(job => job.name === 'All');
    const isAllSelected = selectedJobs.includes(allJob);

    if (isAllSelected) {
      this.selectedJobs = [allJob];
      this.searchForm.patchValue({ selectedJobs: [allJob] });
    }
  }

  isOptionDisabled(job) {
    const allSelected = this.selectedJobs.some(j => j.name === 'All');
    return allSelected && job.name !== 'All';
  }

  openPopup(): void {
    this.notificationService.open();
  }

  toggleSelection(job) {
    job.selected = !job.selected;
    if (job.selected) {
      this.selectedJobs.push(job);
    } else {
      this.selectedJobs = this.selectedJobs.filter(j => j !== job);
    }
  }

  updateStatus(statusValue: DFStatus) {
    if (statusValue != null) {
      this.filters.statusCode = statusValue.id
    } else {
      this.filters.statusCode = null;
    }
  }

dateRangeValidator(group: FormGroup): ValidationErrors | null {
  const startDate = moment(group.controls['startDate'].value);
  const endDate = moment(group.controls['endDate'].value);

  if (startDate && endDate && startDate.isAfter(endDate)) {
    return { invalidRange: true };
  }
  return null;
}


  filterNoOfAssets() {
    this.selectedCard = 'Asset Search';
    this.applySearch();
  }

  filterNoOfLoads() {
    this.selectedCard = 'Load Search';
    this.applySearch();
  }

  filterAutomaticCharges() {
    this.selectedCard = 'Auto Calculation';
    this.applySearch();
  }

  filterNoOfVouchers() {
    this.selectedCard = 'Voucher Update';
    this.applySearch();
  }

  filterNoOfCarriers() {
    this.selectedCard = 'Carrier Search';
    this.applySearch();
  }

  filterAssetsOrCarriers() {
    if (this.countryCode === 'USA') {
      this.filterNoOfCarriers();
    } else {
      this.filterNoOfAssets();
    }
  }

  getNotEligibleRecordsTooltip(notEligibleRecords: any): string {
    if (!notEligibleRecords) {
     return '';
    }
    const { partialSuccessCount, successCount, notEligibleLoads } = notEligibleRecords;
    return `Partial Success Count: ${partialSuccessCount}, Success Count: ${successCount}, Not Eligible Loads: ${JSON.stringify(notEligibleLoads)}`;
}

openContextualData(logEvent: LogsData) {
  this.loader.startLoad();

  this.jsonEditorService.createJsonEditorDoc(`log-event-insight-data-${logEvent.id}`, logEvent.notEligibleRecords)
    .pipe(finalize(() => this.loader.stopLoad()))
    .subscribe(result => {
      if (result.ok) {
        window.open(`http://jsoneditoronline.org/?id=${result.id}`, '_blank');
      }
    });
}

copyJson(data: string) {
  if (this.clipboard.copy(data)) {
    this.toastr.success(this.translate.instant('copy.success'));
  } else {
    this.toastr.error(this.translate.instant('copy.error'));
  }
}

  displayStatusCountList(...config) {
    this.loader.startLoad();
    const mConfig = {
      page: config[0] - 1,
      pageSize: config[1],
      sortColumn: config[2],
      direction: config[3],
      countryCode:  this.countryCode,
      filters: this.filters
    };
    this.dfManagementService.getStatusCountList(mConfig)
    .pipe(finalize(() => this.loader.stopLoad()))
    .subscribe((responce: MyDFStatusCountList) => {
      this.pageTransData = responce;
    }, (error: HttpErrorResponse) => {
      this.pageTransData = null;
      this.toastr.error(error['error_message'] || this.translate.instant('data-table.errors.load-page'));
    })
  }

  getDFCountryResponse() {
    this.loader.startLoad();
    this.dfManagementService.getAllcountry()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(country => {
        this.translatePlaceholders();
        this.countryData = country.results;
        this.countryData.sort((a, b) => (a.countryCode > b.countryCode) ? 1 : -1)
      }, (error: HttpErrorResponse) => {
        this.translatePlaceholders();
        this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-fetching-country')
        );
      });
  }

  updateCountry(country: DFCountry): void {
    this.countryCode = country?.countryCode;
    if (this.countryCode === 'USA') {
      this.jobs = [
        { id: 1, name: 'All'},
        { id: 2, name: 'Carrier Search'},
        { id: 3, name: 'Load Search' },
        { id: 4, name: 'Voucher Update'},
        { id: 4, name: 'BTF upload'}
      ];
    } else {
      this.jobs = [
        { id: 1, name: 'All'},
        { id: 2, name: 'Asset Search'},
        { id: 3, name: 'Load Search' },
        { id: 4, name: 'Auto Calculation' },
        { id: 5, name: 'Voucher Update'}
      ];
    }
  }

applySearch() {
  this.isVisibleCards = true;
  const tempFilters = this.filters;

  const selectedJobs = this.searchForm.value.selectedJobs;

  const allSelected = selectedJobs && selectedJobs.length === 1 && selectedJobs[0].name === 'All';

  if (allSelected) {
    tempFilters.jobNames = null;
  } else {
    const selectedJobNames = selectedJobs ? selectedJobs.map(job => job.name) : '';

    tempFilters.jobNames = selectedJobNames.length > 0 ? selectedJobNames : null;
  }

  tempFilters.jobStatus = this.searchForm.value.status;

  if (!allSelected && !selectedJobs?.length && this.searchForm.value.country) {
    tempFilters.country = this.searchForm.value.country.countryCode;
  }

  if (this.selectedCard) {
    const job = this.jobs.find(j => j.name === this.selectedCard);
    if (job) {
      this.searchForm.patchValue({ selectedJobs: [job] });
      tempFilters.jobNames = [job.name];
    }
  }

  if (!allSelected && selectedJobs && selectedJobs.length > 0) {
    this.selectedCard = null;
  }

  tempFilters.jobStartDate = this.searchForm.value.startDate;
  tempFilters.jobEndDate = this.searchForm.value.endDate;

  if (this.selectedCard === 'Asset Search') {
    tempFilters.jobNames = 'Asset Search';
  } else if (this.selectedCard === 'Load Search') {
    tempFilters.jobNames = 'Load Search';
  } else if (this.selectedCard === 'Auto Calculation') {
    tempFilters.jobNames = 'Auto Calculation';
  } else if (this.selectedCard === 'Voucher Update') {
    tempFilters.jobNames = 'Voucher Update';
  } else if (this.selectedCard === 'Carrier Search') {
    tempFilters.jobNames = 'Carrier Search';
  }
  tempFilters.jobStartDate = this.searchForm.value.startDate;
  tempFilters.jobEndDate = this.searchForm.value.endDate;
  this.filters = tempFilters;

  this.loadPage = (...config): any => {
    this.loader.startLoad();
    const mConfig = {
      page: config[0] - 1,
      pageSize: config[1],
      sortColumn: config[2],
      direction: config[3],
      countryCode: this.countryCode,
      filters: this.filters
    };
    this.displayStatusCountList(...config);
    return this.dfManagementService.getLogsBasedOnDates(mConfig, this.countryCode)
      .pipe(finalize(() => this.loader.stopLoad()));
  };
}
}
